import { ErrorHandler } from '@src/shared/ui/components/ErrorHandler';
import { Widget } from '@src/shared/ui/components/Widget';
import { Skeleton } from '@src/shared/ui/components/Widget/components/Skeleton';
import { isEmpty } from 'lodash';
import React from 'react';

import { Table } from './components/Table';

/**
 * Widget: RiskCode
 *
 * @TODO Needs description.
 *
 * @param data
 * @param riskCodes
 * @returns {Element}
 * @constructor
 */
export function RiskCode({ data = {}, riskCodes = [] }) {
  return (
    <ErrorHandler location="src/widgets/RiskRecords/RiskCode/RiskCode.jsx">
      {isEmpty(data) ? (
        <Skeleton />
      ) : (
        <Widget description={data?.description || ''} title={data?.name || 'Risk Code'}>
          {data?.defaultView === 'table' && (
            <Table
              riskCodes={riskCodes}
              rows={data?.data?.content?.map((row) => {
                return {
                  amount: row?.total,
                  code: row?.label,
                };
              })}
            />
          )}
        </Widget>
      )}
    </ErrorHandler>
  );
}
